import type { ApiClient } from '../../core/api-client.js';
import { ApiError } from '../../core/api-client.js';
import type { Resultado } from '../../core/resultado.js';
import type { Envio, FiltroEnvio, DespacharEnvioInput } from '@pgcustom/shared-types';

/**
 * Adapter do módulo Envios no frontend — único ponto que conhece o
 * formato das rotas `/api/v1/envios/*`
 * (`apps/api/src/modules/envios/envios.routes.ts`). Mesmo padrão de
 * `EstoqueApi`. Sem `criar`: envio só nasce de listener de evento
 * (`ops.concluida`), nunca via HTTP.
 */
export class EnviosApi {
  constructor(private readonly api: ApiClient) {}

  async listar(filtro: FiltroEnvio = {}): Promise<Resultado<Envio[]>> {
    try {
      const resposta = await this.api.get<{ envios: Envio[] }>('/envios', { ...filtro });
      if (resposta.envios.length === 0) return { status: 'vazio' };
      return { status: 'ok', dado: resposta.envios };
    } catch (erro) {
      if (erro instanceof ApiError && erro.status === 403) return { status: 'sem-permissao' };
      return { status: 'erro', mensagem: erro instanceof ApiError ? erro.message : 'falha ao carregar envios' };
    }
  }

  async despachar(id: string, dado: DespacharEnvioInput): Promise<Envio> {
    const resposta = await this.api.post<{ envio: Envio }>(`/envios/${id}/despachar`, dado);
    return resposta.envio;
  }

  async marcarComoEntregue(id: string): Promise<Envio> {
    const resposta = await this.api.post<{ envio: Envio }>(`/envios/${id}/entregar`, {});
    return resposta.envio;
  }
}
